var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCrossAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.5,
    height: 25,
    x: 8.75,
    y: -2.5,
    rx: 1.25,
    transform: "rotate(45 10 10)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.5,
    height: 25,
    x: 8.75,
    y: -2.5,
    rx: 1.25,
    transform: "rotate(-45 10 10)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCrossAlt);
export default __webpack_public_path__ + "static/media/close-cross--alt.ec8bcf1949b68b945c487acd3622b506.svg";
export { ForwardRef as ReactComponent };